import loadable from '@loadable/component';
import PropTypes from 'prop-types';

import PageLoader from 'components/Loaders/PageLoader';

import retry from 'utils/network/retry';

export default function AsyncLoadablePage({ routeObj, ...props }) {
  return (
    <Page
      {...props}
      routeObj={routeObj}
      pageFileName={routeObj.name}
      fallback={<PageLoader forceDisplay={true} />}
    />
  );
}

AsyncLoadablePage.propTypes = {
  routeObj: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

const Page = loadable(props => {
  const { pageFileName } = props;

  return retry(() =>
    import(/* webpackChunkName: "[request]" */ `../pages/${pageFileName}`)
  );
});
